
<div
class="chart"
*ngIf="dataFromApi" [chart]="chart"></div>
